// extracted by mini-css-extract-plugin
module.exports = {"ellipsisDefaultStyle":"ellipsis-with-tooltip_ellipsisDefaultStyle__E4ivi"};